import React from 'react';
import { useAuth } from '../../context/AuthContext';

const LandingPage = () => {
  const { login } = useAuth();

  const signupAs = (role) => {
    sessionStorage.setItem('dancehall_signup_role', role);
    login({ authorizationParams: { screen_hint: 'signup' } });
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-brand-50 to-white">
      {/* Nav */}
      <div className="max-w-5xl mx-auto px-6 pt-6 flex justify-end gap-3">
        <button
          onClick={() => signupAs('student')}
          className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors"
        >
          Sign up as Student
        </button>
        <button
          onClick={() => signupAs('teacher')}
          className="text-sm font-medium text-brand-500 hover:text-brand-600 transition-colors"
        >
          Sign up as Teacher
        </button>
        <button
          onClick={() => login()}
          className="text-sm font-medium text-white bg-brand-500 hover:bg-brand-600 px-4 py-1.5 rounded-lg transition-colors"
        >
          Log in
        </button>
      </div>

      {/* Hero */}
      <div className="max-w-5xl mx-auto px-6 pt-14 pb-16 text-center">
        <h1 className="text-5xl font-bold text-gray-900 mb-6">
          Run your dance studio.<br />
          <span className="text-brand-500">Not spreadsheets.</span>
        </h1>
        <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
          Enrollment, payments, attendance, and class materials — all in one place.
          Free for studios. Students pay a small 2.99% service fee.
        </p>
        <div className="flex items-center justify-center gap-4">
          <button
            onClick={() => signupAs('teacher')}
            className="bg-brand-500 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-brand-600 transition-colors"
          >
            I'm a Teacher
          </button>
          <button
            onClick={() => signupAs('student')}
            className="bg-white text-brand-500 border-2 border-brand-500 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-brand-50 transition-colors"
          >
            I'm a Student
          </button>
        </div>
        <p className="text-sm text-gray-500 mt-4">
          No credit card required. Set up in 10 minutes.
        </p>
      </div>

      {/* Value Props */}
      <div className="max-w-5xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-8">
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
          <div className="text-3xl mb-4">&#128176;</div>
          <h3 className="font-semibold text-lg mb-2">Payments on Autopilot</h3>
          <p className="text-gray-600">
            Students enroll and pay online. Monthly or one-time.
            Money goes straight to your bank. No more chasing Venmo.
          </p>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
          <div className="text-3xl mb-4">&#9989;</div>
          <h3 className="font-semibold text-lg mb-2">Attendance in 15 Seconds</h3>
          <p className="text-gray-600">
            Open your phone, check off who's here, done.
            Zoom classes auto-tracked. No more spreadsheets.
          </p>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
          <div className="text-3xl mb-4">&#127909;</div>
          <h3 className="font-semibold text-lg mb-2">Tutorial Videos That Unlock</h3>
          <p className="text-gray-600">
            Upload your YouTube tutorials once. Students unlock them
            as they attend classes. Automated, every semester.
          </p>
        </div>
      </div>

      {/* How it works */}
      <div className="bg-gray-50 py-16">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-12">Built for Indian Classical Dance</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h3 className="font-semibold text-lg mb-4">Your studio, your courses</h3>
              <ul className="space-y-3 text-gray-600">
                <li>Create levels: Baala, Stage 1, Stage 2, Margam...</li>
                <li>Set your own pricing: monthly, quarterly, or one-time blocks</li>
                <li>Schedule classes with timezone support</li>
                <li>Online (Zoom), in-person, or hybrid</li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold text-lg mb-4">Keep 100% of your fees</h3>
              <ul className="space-y-3 text-gray-600">
                <li>Students pay a small 2.99% service fee on top</li>
                <li>Payments go directly to your bank via Stripe</li>
                <li>ACH (bank transfer) option saves students even more</li>
                <li>No monthly fees, no contracts, no lock-in</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="max-w-5xl mx-auto px-6 py-16 text-center">
        <h2 className="text-3xl font-bold mb-6">Ready to ditch the spreadsheets?</h2>
        <div className="flex items-center justify-center gap-4">
          <button
            onClick={() => signupAs('teacher')}
            className="bg-brand-500 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-brand-600 transition-colors"
          >
            Create Your Studio
          </button>
          <button
            onClick={() => signupAs('student')}
            className="bg-white text-brand-500 border-2 border-brand-500 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-brand-50 transition-colors"
          >
            Join as Student
          </button>
        </div>
      </div>

      {/* Footer */}
      <footer className="border-t border-gray-200 py-8 text-center text-sm text-gray-500">
        DanceHall Studios &middot; Built for the Indian dance community
      </footer>
    </div>
  );
};

export default LandingPage;
